import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Button, CircularProgress } from '@mui/material';
import { MdRefresh } from 'react-icons/md';
import api from '../utils/api';

/**
 * AdminController / Hr only — clears Mongo insight cache for one AI section.
 * @param {{
 *   surface: 'overview'|'operations'|'room'|'efficacy'|'subscription',
 *   cacheParams: Record<string, string | undefined>,
 *   onInvalidated?: () => void | Promise<void>,
 *   disabled?: boolean,
 * }} props
 */
export default function AdminInvalidateInsightCacheButton({
  surface,
  cacheParams,
  onInvalidated,
  disabled = false,
}) {
  const { adminView } = useOutletContext() || {};
  const [busy, setBusy] = useState(false);

  if (!adminView) return null;

  const handleClick = async () => {
    setBusy(true);
    try {
      const params = { surface, ...cacheParams };
      Object.keys(params).forEach((k) => {
        if (params[k] == null || params[k] === '') delete params[k];
      });
      await api.delete('/client/insights/cache', { params });
      if (onInvalidated) await onInvalidated();
    } catch (e) {
      console.error('Invalidate insight cache error:', e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      disabled={disabled || busy}
      onClick={handleClick}
      startIcon={busy ? <CircularProgress size={14} /> : <MdRefresh size={16} />}
      sx={{
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.75rem',
        borderColor: 'rgba(90, 82, 189, 0.45)',
        color: '#5A52BD',
        bgcolor: 'rgba(255,255,255,0.6)',
        '&:hover': {
          borderColor: '#5A52BD',
          bgcolor: 'rgba(255,255,255,0.9)',
        },
      }}
    >
      Refresh AI cache
    </Button>
  );
}
